import { BreakpointRangeWithFallback } from '../types';

// Temporary solution for having the Design Systems breakpoints utils to work also with the Commander breakpoints logic
export const getBreakpointRangeValueFallback = (breakpointRange: BreakpointRangeWithFallback) =>
    'value' in breakpointRange ? breakpointRange.value : breakpointRange;
